import { Link } from 'react-router-dom';
import WatchMockup from '../../apps/watchai/components/WatchMockup';
import { PRICE_USD } from '../../../content/watchai';

/**
 * Secondary promo for the consumer WatchAI app, shown low on the B2B homepage
 * (immediately above the footer). Deliberately understated — emerald app accent
 * instead of the blue business brand, an "Also from…" eyebrow — so it
 * complements rather than competes with the primary customer-service message.
 * The CTA is an honest "Explore WatchAI" (the app is not yet published); there
 * is no Play Store link or purchase button here.
 */
export default function AppsPromo() {
  return (
    <section aria-labelledby="apps-promo-heading" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl bg-gradient-to-br from-emerald-50 to-teal-50 border border-emerald-100 p-8 md:p-12">
          <div className="flex flex-col md:flex-row items-center gap-10">
            <div className="flex-1">
              <div className="text-sm font-semibold text-emerald-700 uppercase tracking-wider mb-3">
                Also from 24/7 AI 360
              </div>
              <h2 id="apps-promo-heading" className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                WatchAI — your AI assistant, on your wrist
              </h2>
              <p className="text-lg text-gray-600 max-w-xl mb-6">
                A consumer app for Wear OS: ask any AI by voice or text from your
                watch, using your own key for Google Gemini, OpenAI or Anthropic
                Claude. ${PRICE_USD} one-time, no subscription.
              </p>
              <div className="flex flex-wrap items-center gap-4">
                <Link
                  to="/apps/watchai"
                  className="inline-flex items-center gap-2 bg-emerald-600 hover:bg-emerald-700 text-white px-6 py-3 rounded-lg font-semibold transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-emerald-500"
                >
                  Explore WatchAI <i className="ri-arrow-right-line" aria-hidden="true"></i>
                </Link>
                <span className="text-sm text-gray-500">Coming soon to Google Play</span>
              </div>
            </div>
            <div className="flex-none">
              <WatchMockup className="w-40 h-52 drop-shadow-xl" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
